import { ActionEventAction } from 'services/Analytics/core';

export enum linkType {
    Primary = 'primary',
    Secondary = 'secondary',
}

export type SidebarLinkProps = {
    to: string;
    title: string;
    dataLocator?: string;
    onClick?: (to?: string) => void;
    color?: string;
    type: linkType;
    target?: string;
    rel?: string;
    itemLabel?: React.FC;
};

export type SidebarLinkButtonProps = {
    isActive: boolean;
    title: string;
};

export type SidebarLinkItem = {
    to: string;
    title: string;
    dataLocator: string;
    eventAction: ActionEventAction | string;
    target?: string;
    rel?: string;
    [key: string]: any;
};

export type LinkListProps = {
    links: SidebarLinkItem[];
    onLinkClick: (eventAction: any) => void;
};
